import { Suspense, lazy } from "react";
import "@/App.css";

// Lazy load Three.js scene for performance
const ThreeScene = lazy(() => import("@/components/ThreeScene"));
const UIOverlay = lazy(() => import("@/components/UIOverlay"));

// Loading component
const Loader = () => (
  <div className="loader" data-testid="loader">
    <div className="loader-text">LOADING</div>
    <div className="loader-bar">
      <div className="loader-progress"></div>
    </div>
  </div>
);

function App() {
  return (
    <div className="app-container" data-testid="app-container">
      <Suspense fallback={<Loader />}>
        <ThreeScene />
        <UIOverlay />
      </Suspense>
      
      {/* Grain overlay for cinematic effect */}
      <div className="grain-overlay" aria-hidden="true"></div>
    </div>
  );
}

export default App;
